<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectReason,
} from '../../../../model/additional-info/billing/info-chargeback/select-reason.hook'

defineOptions({
  name: 'SelectReason',
})

const {
  placeholder,
  model,
  options,
} = useSelectReason()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
